(() => {
  if (window.goldenMateProductCardVariantsInitialized) return;

  window.goldenMateProductCardVariantsInitialized = true;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const switcher = event.target.closest('[data-gm-card-variant-switch]');

    if (!switcher || switcher.disabled) return;

    const card = switcher.closest('.product-card--spec-rich');
    const swatchItem = switcher.closest('li');

    if (!card || !swatchItem) return;

    card.querySelectorAll('[data-gm-card-variant-switch]').forEach((control) => {
      control.setAttribute('aria-pressed', control === switcher ? 'true' : 'false');
    });

    const priceTemplate = swatchItem.querySelector('[data-gm-card-variant-price]');
    const currentPrice = card.querySelector('.gm-product-card__price');
    const nextPrice = priceTemplate?.content.firstElementChild?.cloneNode(true);

    if (currentPrice && nextPrice) currentPrice.replaceWith(nextPrice);

    const mediaTemplate = swatchItem.querySelector('[data-gm-card-variant-media]');
    const currentImage = card.querySelector('.product-card__media > a.media > img');
    const nextImage = mediaTemplate?.content.querySelector('img')?.cloneNode(true);

    if (currentImage && nextImage) currentImage.replaceWith(nextImage);

    const variantUrl = switcher.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('[data-gm-card-product-link]').forEach((link) => {
        link.href = variantUrl;
      });
    }

    const shopNow = card.querySelector('.gm-product-card__cta-shop');
    const variantCartUrl = switcher.dataset.variantCartUrl;

    if (shopNow && variantCartUrl) shopNow.href = variantCartUrl;

    card.dataset.selectedVariantId = switcher.dataset.variantId;
  });
})();
